import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import { setLocalStore } from '../../shares/lib/localStore';
import { LocalStoreKeys } from '../../shares/enums/localStoreKeys';
import { createSwipeIcon } from '../../widgets/domRenderer';
import removeSwipeSdk from '../../features/removeSwipeSdk';
import eventEmitters from '../../shares/lib/eventEmitters';
import eventType from '../../shares/enums/eventType';
import logger from '../../shares/lib/logger';
import { setSwipeSdkConfig } from '../config/setSwipeSdkConfig';

export const SwipeGames = {
  launch: async (): Promise<void> => {
    const swipeSDKConfig = getSDKConfig();
    localStorage.removeItem(LocalStoreKeys.IS_SWIPE_SDK_INITIATED);

    if (!swipeSDKConfig?.enableSwipeGames) {
      return;
    }

    await setSwipeSdkConfig();

    if (!swipeSDKConfig.swipeGames?.gameListConfig?.gameList?.length) {
      logger.error('No games found in the configuration');
      return;
    }

    createSwipeIcon();
    setLocalStore(LocalStoreKeys.IS_SWIPE_SDK_INITIATED, true);
  },

  remove: async (): Promise<void> => {
    removeSwipeSdk();
    setLocalStore(LocalStoreKeys.IS_SWIPE_SDK_INITIATED, false);
    eventEmitters(eventType.SWIPE_CLOSED);
    logger.warn('The Swipe SDK has been closed or removed.');
  },
};
